import script from "./DragDropImageUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./DragDropImageUploader.vue?vue&type=script&setup=true&lang=js"

import "./DragDropImageUploader.vue?vue&type=style&index=0&id=509f1672&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-509f1672"]])

export default __exports__